<template>
    <el-dialog :visible="openDialog"
               :close-on-click-modal="false"
               :close-on-press-escape="!processing"
               :show-close="!processing"
               @opened="initAutocomplete"
               @close="$emit('update:openDialog', false)"
               :title="(eraseModeOn ? 'Remove' : 'Add') + ' City or State'">

        <el-form :model="formData">
            <el-form-item label="Hiring Area" id="pac-container">
                <div class="el-input">
                    <input type="text"
                           ref="autocomplete"
                           class="el-input__inner"
                           :disabled="processing"
                           @keyup="autocompleteTextChanged"
                           v-model="formData.locationName"/>
                </div>

            </el-form-item>
            <el-form-item v-if="isRadiusVisible" label="Include area of">
                <el-select v-model="formData.radius" style="width:100%">
                    <el-option value="100" label="100 miles"/>
                    <el-option value="75" label="75 miles"/>
                    <el-option value="50" label="50 miles"/>
                    <el-option value="25" label="25 miles"/>
                </el-select>
            </el-form-item>
        </el-form>

        <el-alert v-if="errorMessage !== null" title="Error: " type="error" :closable="false">
            {{ errorMessage }}
        </el-alert>

        <span slot="footer" class="dialog-footer">
            <el-button :disabled="processing" @click="$emit('update:openDialog', false)">Cancel</el-button>
            <el-button :disabled="processing" :type="eraseModeOn ? 'danger' : 'success'" @click="process">
                <i v-if="processing" class="fa fa-pulse fa-spinner"></i> {{ eraseModeOn ? 'Remove' : 'Add' }}
            </el-button>
        </span>

    </el-dialog>
</template>

<script>
    export default {
        props: {
            areaId: { type: Number, required: true },
            openDialog: { type: Boolean, required: true },
            eraseModeOn: { type: Boolean, required: true },
            gmapsObj: { type: Object, required: true },
            map: { type: Object, required: false },
            mapUrl: { type: Function, required: true }
        },
        data() {
            return {
                formData: {
                    locationName: '',
                    radius: '100',
                    lat: '',
                    lng: '',
                    administrativeAreaLevel1: '',
                    locality: '',
                },
                isRadiusVisible: false,
                processing: false,
                errorMessage: null,
                autocomplete: null,
            };
        },
        methods: {
            initAutocomplete() {
                this.autocomplete = new this.gmapsObj.places.Autocomplete(this.$refs.autocomplete, {
                    types: ["(regions)"]
                });

                if (this.map !== null) {
                    this.autocomplete.bindTo('bounds', this.map);
                }
                this.autocomplete.setComponentRestrictions({ country: 'us' });
                this.autocomplete.addListener('place_changed', this.onPlaceChanged);
            },
            autocompleteTextChanged() {
                this.$set(this.formData, 'lat', '');
                this.$set(this.formData, 'lng', '');
                this.$set(this.formData, 'administrativeAreaLevel1', '');
                this.$set(this.formData, 'locality', '');

                this.isRadiusVisible = false;
            },
            onPlaceChanged() {
                this.errorMessage = null;
                const place = this.autocomplete.getPlace();

                if (!place.geometry || typeof place.address_components === 'undefined') {
                    this.errorMessage = 'No such place found.';
                    return;
                }

                this.$set(this.formData, 'locationName', this.$refs.autocomplete.value);
                this.$set(this.formData, 'lat', place.geometry.location.lat());
                this.$set(this.formData, 'lng', place.geometry.location.lng());

                for(let index in place['address_components']) {
                    if (!place['address_components'].hasOwnProperty(index)) continue;
                    place['address_components'][index].types.forEach(type => {
                        switch(type) {
                            case 'locality':
                                this.$set(this.formData, 'locality', place['address_components'][index]['long_name']);
                                break;
                            case 'administrative_area_level_1':
                                this.$set(this.formData, 'administrativeAreaLevel1',
                                    place['address_components'][index]['long_name']);
                                break;
                        }
                    });
                }

                this.isRadiusVisible = this.formData.locality !== '';
            },
            process() {
                if (this.formData.locationName === '' || this.formData.lat === '' || this.formData.lng === '') {
                    this.errorMessage = 'City or state need to be filled and selected from drop down menu.';
                    return;
                }

                this.processing = true;
                this.errorMessage = null;

                axios.post(this.url(`admin/area/add-city-radius`),
                    _.merge(this.formData, { is_exclusion: this.eraseModeOn, area_id: this.areaId }))
                    .then(response => {
                        if (typeof response.data.error !== 'undefined') {
                            this.errorMessage = response.data.error;
                        } else {
                            this.$set(this.formData, 'lat', '');
                            this.$set(this.formData, 'lng', '');
                            this.$set(this.formData, 'administrativeAreaLevel1', '');
                            this.$set(this.formData, 'locality', '');
                            this.$set(this.formData, 'locationName', '');
                            this.$set(this.formData, 'radius', '100');
                            this.isRadiusVisible = false;
                            this.$emit('process');
                            this.$emit('update:openDialog', false);
                        }
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            },
        },
    };
</script>

<style>
    .pac-container {
        z-index: 2100; /*over element ui dialog*/
    }
</style>
